import React, { useState, useEffect } from 'react';
import { RemoveSearchIcon, SearchBarIcon } from '../../../components/common/SvgIcon';

const TemplateSearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(query);
    }, 500);

    return () => clearTimeout(timer);
  }, [query, onSearch]);

  return (
    <div className="relative w-[448px]">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <SearchBarIcon />
      </div>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search by template name..."
        className="w-full h-11 !bg-[#FAFAFA] !pl-10 pr-10 py-3 border !border-[#E4E4E7] rounded-xl focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none"
      />
      {query && (
        <button
          onClick={() => setQuery('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
        >
          <RemoveSearchIcon />
        </button>
      )}
    </div>
  );
};

export default TemplateSearchBar;